/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  BillingPlansRetrieve200,
  BillingSubscriptionRetrieve200,
  BillingUsage,
  CheckoutRequestRequest,
  CheckoutResponse,
  PaginatedInvoice,
  PortalResponse
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Creates a Stripe Customer for the company on first call (idempotent), then opens a Checkout session for exactly one of `priceId`, `creditPackCode` (one-off payment; credits land via webhook) or `planCode` (subscription). The resolved price must be in `STRIPE_ALLOWED_PRICE_IDS`. Returns the hosted URL — frontend redirects the browser there.
 * @summary Start a Stripe Checkout session
 */
export const billingCheckoutCreate = (
    checkoutRequestRequest: CheckoutRequestRequest,
 ) => {
      
      
      return customInstance<CheckoutResponse>(
      {url: `/api/v1/billing/checkout/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkoutRequestRequest
    },
      );
    }
  


export const getBillingCheckoutCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingCheckoutCreate>>, TError,{data: CheckoutRequestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof billingCheckoutCreate>>, TError,{data: CheckoutRequestRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingCheckoutCreate>>, {data: CheckoutRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  billingCheckoutCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingCheckoutCreateMutationResult = NonNullable<Awaited<ReturnType<typeof billingCheckoutCreate>>>
    export type BillingCheckoutCreateMutationBody = CheckoutRequestRequest
    export type BillingCheckoutCreateMutationError = void

    /**
 * @summary Start a Stripe Checkout session
 */
export const useBillingCheckoutCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingCheckoutCreate>>, TError,{data: CheckoutRequestRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof billingCheckoutCreate>>,
        TError,
        {data: CheckoutRequestRequest},
        TContext
      > => {

      const mutationOptions = getBillingCheckoutCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Most-recent first. Empty list if the company has no Stripe customer yet.
 * @summary List the company's invoices
 */
export const billingInvoicesRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedInvoice>(
      {url: `/api/v1/billing/invoices/`, method: 'GET', signal
    },
      );
    }
  

export const getBillingInvoicesRetrieveQueryKey = () => {
    return [`/api/v1/billing/invoices/`] as const;
    }

    
export const getBillingInvoicesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingInvoicesRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingInvoicesRetrieve>>> = ({ signal }) => billingInvoicesRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type BillingInvoicesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof billingInvoicesRetrieve>>>
export type BillingInvoicesRetrieveQueryError = unknown

/**
 * @summary List the company's invoices
 */
export const useBillingInvoicesRetrieve = <TData = Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getBillingInvoicesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns the plans configured via `STRIPE_PLANS` — each entry has `priceId`, `name`, `amount`, `currency`, `interval`, and an optional `description`. Empty when billing isn't yet configured. Auth required; same eligibility as the other billing endpoints.
 * @summary List subscribable plans
 */
export const billingPlansRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<BillingPlansRetrieve200>(
      {url: `/api/v1/billing/plans/`, method: 'GET', signal
    },
      );
    }
  

export const getBillingPlansRetrieveQueryKey = () => {
    return [`/api/v1/billing/plans/`] as const;
    }

    
export const getBillingPlansRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof billingPlansRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPlansRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingPlansRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingPlansRetrieve>>> = ({ signal }) => billingPlansRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingPlansRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type BillingPlansRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof billingPlansRetrieve>>>
export type BillingPlansRetrieveQueryError = void

/**
 * @summary List subscribable plans
 */
export const useBillingPlansRetrieve = <TData = Awaited<ReturnType<typeof billingPlansRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPlansRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getBillingPlansRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a one-time URL into Stripe's hosted billing portal where the user can update their payment method, cancel, view past invoices, etc. The customer must already exist (i.e. they've completed at least one checkout); if not, returns 404.
 * @summary Open the Stripe Customer Portal
 */
export const billingPortalCreate = (
    
 ) => {
      
      
      return customInstance<PortalResponse>(
      {url: `/api/v1/billing/portal/`, method: 'POST'
    },
      );
    }
  


export const getBillingPortalCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingPortalCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof billingPortalCreate>>, TError,void, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingPortalCreate>>, void> = () => {
          

          return  billingPortalCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingPortalCreateMutationResult = NonNullable<Awaited<ReturnType<typeof billingPortalCreate>>>
    
    export type BillingPortalCreateMutationError = void

    /**
 * @summary Open the Stripe Customer Portal
 */
export const useBillingPortalCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingPortalCreate>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof billingPortalCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getBillingPortalCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns `{subscription: ...}` for the company's most-recent subscription, or `{subscription: null}` if the company has never subscribed. Wrapping the nullable so the response always has a Content-Type and clients can rely on a stable shape.
 * @summary Get the company's current subscription
 */
export const billingSubscriptionRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<BillingSubscriptionRetrieve200>(
      {url: `/api/v1/billing/subscription/`, method: 'GET', signal
    },
      );
    }
  

export const getBillingSubscriptionRetrieveQueryKey = () => {
    return [`/api/v1/billing/subscription/`] as const;
    }

    
export const getBillingSubscriptionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof billingSubscriptionRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingSubscriptionRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingSubscriptionRetrieve>>> = ({ signal }) => billingSubscriptionRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type BillingSubscriptionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof billingSubscriptionRetrieve>>>
export type BillingSubscriptionRetrieveQueryError = unknown

/**
 * @summary Get the company's current subscription
 */
export const useBillingSubscriptionRetrieve = <TData = Awaited<ReturnType<typeof billingSubscriptionRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getBillingSubscriptionRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * The company's current plan, credit balance, usage this calendar month (submitted match requests, matches produced, active deals) against the plan's limits (null = unlimited), and the credit packs on sale (WP2.4).
 * @summary Plan, credits and usage this month
 */
export const billingUsageRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<BillingUsage>(
      {url: `/api/v1/billing/usage/`, method: 'GET', signal
    },
      );
    }
  

export const getBillingUsageRetrieveQueryKey = () => {
    return [`/api/v1/billing/usage/`] as const;
    }

    
export const getBillingUsageRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof billingUsageRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingUsageRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingUsageRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingUsageRetrieve>>> = ({ signal }) => billingUsageRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingUsageRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type BillingUsageRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof billingUsageRetrieve>>>
export type BillingUsageRetrieveQueryError = void

/**
 * @summary Plan, credits and usage this month
 */
export const useBillingUsageRetrieve = <TData = Awaited<ReturnType<typeof billingUsageRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingUsageRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getBillingUsageRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Stripe → backend signed payload. Validates the signature with `STRIPE_WEBHOOK_SECRET`, then applies subscription / invoice / credit-pack checkout events idempotently (keyed on the event id). Returns 200 for unhandled and already-processed events, and 500 when processing fails so Stripe retries.
 * @summary Stripe webhook receiver
 */
export const billingWebhookStripeCreate = (
    
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/billing/webhook/stripe/`, method: 'POST'
    },
      );
    }
  


export const getBillingWebhookStripeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingWebhookStripeCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof billingWebhookStripeCreate>>, TError,void, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingWebhookStripeCreate>>, void> = () => {
          

          return  billingWebhookStripeCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingWebhookStripeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof billingWebhookStripeCreate>>>
    
    export type BillingWebhookStripeCreateMutationError = void

    /**
 * @summary Stripe webhook receiver
 */
export const useBillingWebhookStripeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingWebhookStripeCreate>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof billingWebhookStripeCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getBillingWebhookStripeCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    